import {
  Box,
  Typography,
  Table,
  TableContainer,
  TableRow,
  TableCell,
  TableBody,
  Paper,
} from "@mui/material";
import basestyle from "../../CSS/Base.module.css";
import assetsIcon from '../../../assets/images/Bank-removebg-preview.png';
import { useState, useEffect, JSXElementConstructor, Key, ReactElement, ReactNode, ReactPortal } from "react";
import { useSelector } from "react-redux";
import { RootState } from "../../../store/store";
import { getExpensesSummaryByPId } from "../services/Summary/accountSummaryService";
import * as constants from "../../../constants";
import { formatCurrency } from "../Utils/formatUtils";
import TableRowSummaryDesign from "./SummaryTableRowDesign";
import { useTranslation } from "react-i18next";
import CircularProgress from '@mui/material/CircularProgress';

function Expenses() {
  const userInfo = useSelector((state: RootState) => state.auth);
  const [loading, setLoading] = useState(false);
  const [glNonAssets, setGLNonAssets] = useState<any>([]);
  const [glNonTotalBanalance, setGLNonTotoalBalance] = useState(0);
  const { t } = useTranslation();
  const translate = t as (key: string) => string;

  useEffect(() => {
    getExpensesByPid(userInfo.defaultParticipantId, userInfo.clientId);
  }, [userInfo?.defaultParticipantId]);

  async function getExpensesByPid(pId: number, clientId: number) {
    try {
      setLoading(true);
      const resLoanByPid = await getExpensesSummaryByPId(pId, clientId);
      if (resLoanByPid.status == constants.STATUS_CODES.SUCCESS) {
        setGLNonAssets(resLoanByPid.data.data.glNonAssets);
        setGLNonTotoalBalance(resLoanByPid.data.data.totalBalance);
      }
    } catch (error) {
      console.error(translate("errorHandlingFundSource"), error);
    } finally {
      setLoading(false);
    }
  }
  return (
    <Paper sx={{ display: "flex", backgroundColor: "transparent", boxShadow: "none", borderRadius: "18px" }}>
      <Box className={basestyle.assetsContainer}>
        <Box className={basestyle.circleWhite}>
          <img src={assetsIcon} alt="Expenses Logo" className="LabilitiesLogo" style={{ width: "80px", height: "auto" }} />
        </Box>
        <Typography variant="h5" className={basestyle.assetsText}>
          {translate('expenses')}
        </Typography>
      </Box>
      {loading ? (
        <Box className="loadingContainer">
          <CircularProgress size={20} />
          <Typography variant="body2" sx={{ marginLeft: 1 }}>
            Loading...
          </Typography>
        </Box>
      ) : (
        <TableContainer className={basestyle.mainTableContainer}>
          <Table size="small" sx={{ borderCollapse: "collapse" }}>
            <TableBody>
              {glNonAssets.map((item:any, index: React.Key | null | undefined) => (
                <TableRowSummaryDesign key={index} variant="changeOddtoEven">
                  <TableCell sx={{ border: "none" }}>
                    <Typography sx={{ color: "black" }}>
                      {item.glAcctName}
                    </Typography>
                  </TableCell>
                  <TableCell
                    align="right"
                    className={basestyle.amountText}
                    sx={{ border: "none", fontSize:"16px" }}
                  > 
                    {formatCurrency(item.glAcctBalance)}
                  </TableCell>
                </TableRowSummaryDesign>
              ))}

              {/* Total Available Balance Row */}
              <TableRow className={basestyle.totalAmountStyle}>
                <TableCell className={basestyle.tableCellStyle} sx={{ border: "none" }} />
                <TableCell
                  align="right"
                  className={basestyle.tableCellStyle}
                  sx={{ border: "none" }}
                >
                  <Typography>
                    <span className={basestyle.labelBoldText}>
                      {translate("totalAvailableBalance")}
                    </span> 
                    &nbsp;
                    <span
                      className={basestyle.amountTotalAvaliable}
                      style={{display: "inline-block", fontWeight:"bold" }}
                    >
                      {formatCurrency(glNonTotalBanalance)}
                    </span>
                  </Typography>
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>
      )} 
    </Paper>
  );
}

export default Expenses;
